import { notificationTypes } from '../../../constants/notificationsTypes'
import type {
  LandingNotification,
  NotificationLandingConfig,
} from '../types/landing'

interface RegistryDeps {
  setAvailability: (
    n: LandingNotification,
    status: 'available' | 'unavailable'
  ) => Promise<void>
}

// type → config. Actions need runtime deps (an RQ mutation), so the registry is
// built from injected deps rather than a module-level const. Unmapped types
// return undefined (caller falls back to title+body+Close).
export const buildLandingRegistry = (
  deps: RegistryDeps
): Record<string, NotificationLandingConfig> => ({
  [notificationTypes.SPARE_AVAILABILITY_REQUEST]: {
    primaryAction: {
      label: 'Yes',
      run: (n) => deps.setAvailability(n, 'available'),
    },
    secondaryAction: {
      label: 'No',
      run: (n) => deps.setAvailability(n, 'unavailable'),
    },
  },
})

export const getLandingConfig = (
  registry: Record<string, NotificationLandingConfig>,
  type: string
): NotificationLandingConfig | undefined => registry[type]
